<div class="row" *ngIf="isAddressTypeVisible">
  <div class="col-12">
    <span> Address Type: </span>
    <div class="form-group location-address-types" [ngClass]="{ 'has-error': addressType.value?.length <= 0 && formDirty }">
      <div class="usrDefined">
        <div class="custom-control custom-radio custom-control-inline">
          <input
            (click)="formDirty = true"
            type="radio"
            id="incorporationAddress"
            name="incorporationAddress"
            [value]="incorporationAddressType"
            class="custom-control-input"
            [disabled]="readOnly"
            [(ngModel)]="filter.addressType"
            required
            #addressType="ngModel"
          />
          <label class="custom-control-label" for="incorporationAddress">Incorporation Address</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            (click)="formDirty = true"
            type="radio"
            id="tradingAddress"
            name="tradingAddress"
            [value]="tradingAddressType"
            class="custom-control-input"
            [disabled]="readOnly"
            [(ngModel)]="filter.addressType"
            required
            #addressType="ngModel"
          />
          <label class="custom-control-label" for="tradingAddress">Trading Address</label>
        </div>
      </div>
      <span class="help-block" *ngIf="formDirty && addressType.value?.length <= 0 && submitClicked && addressType.errors.required">
        Please select an address type
      </span>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 text-right">{{ filter.locationSelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-tree">
  <div class="col-6">
    <div
      style="height: 100%"
      [ngClass]="{ 'has-error': (filter.locationSelection?.length === 0 || filter.locationSelection === null) && submitClicked === true }"
    >
      <div style="height: 100%" class="usrDefined">
        <app-world-regions
          *ngIf="dataLoaded"
          [isFilter]="true"
          [regionCountries]="regionCountries_multi"
          [selectedBenchmarkCountries]="filter.locationSelectionId"
          (afterNodeUnSelect)="nodeUnselect($event)"
          (afterNodeSelect)="nodeSelect()"
          (afterClick)="onWorldRegionsClick()"
          [styleClass]="'location-table'"
        >
        </app-world-regions>
      </div>
    </div>
    <fieldset ngModelGroup="”accountTypes”">
      <input type="hidden" [(ngModel)]="filter.locationSelection" name="locationSelection" #locationSelection="ngModel" required />
      <div class="row">
        <div class="col=12">
          <span class="help-block">
            <span *ngIf="formDirty && locationSelection.invalid"> Please select a location </span>
          </span>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="col-6">
    <p-tree
      *ngIf="dataLoaded"
      id="selectionlocationfilter"
      name="selectionlocationfilter"
      class="selected-tree"
      [(value)]="filter.locationSelection"
      (onNodeUnselect)="nodeUnselect($event, true)"
      [(selection)]="filter.locationSelection"
      [propagateSelectionUp]="true"
      [propagateSelectionDown]="true"
      selectionMode="checkbox"
      emptyMessage=" "
      styleClass="location-table"
    >
    </p-tree>
  </div>
</div>
